import {AnalysisGraphQL, GetAnalysisPipelineStep} from 'analysis-tool/AnalysisTypes';
import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';

import {getChildSteps} from './StepLineageUtils';

export default function hasDownstreamFlagRowsStep(
  analysis: AnalysisGraphQL,
  step: GetAnalysisPipelineStep
): boolean {
  const children = getChildSteps(analysis, step);

  if (children.some((childStep) => childStep.definition.stepType === PipelineStepType.FLAG_ROWS)) {
    return true;
  }

  for (const child of children) {
    if (hasDownstreamFlagRowsStep(analysis, child)) {
      return true;
    }
  }

  return false;
}
